import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-convenio-familia',
  templateUrl: './convenio-familia.component.html',
  styleUrls: ['./convenio-familia.component.css']
})
export class ConvenioFamiliaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
